import React, { useState } from 'react';
import { BeaconProImageFallback } from 'src/components/SvgIcons';
import { useBeaconClientId, useCompanyId } from 'src/utils/Hooks/reduxSelectors';
import { getClientImageUrl } from 'src/utils/image';

export const ClientLogo = ({ displayName }: { displayName: string }) => {
  const beaconClientId = useBeaconClientId();
  const companyId = useCompanyId();
  const [error, setError] = useState(false);

  if (error) {
    return (
      <BeaconProImageFallback
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'cover'
        }}
      />
    );
  }

  return (
    <img
      style={{
        width: '80px',
        height: '80px',
        objectFit: 'contain'
      }}
      alt={displayName}
      src={getClientImageUrl(beaconClientId === -1 ? companyId : beaconClientId)}
      onError={() => setError(true)}
    />
  );
};
